import { __assign, __rest } from '../../node_modules/tslib/tslib.es6.js';
import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import React__default from 'react';
import styled from 'styled-components';
import { width } from '../../node_modules/styled-system/dist/index.esm.js';
import { visuallyHiddenStyle } from '../../utils/visuallyHidden.js';
import { variant } from '../../node_modules/@styled-system/variant/dist/index.esm.js';
import { padding } from '../../node_modules/@styled-system/space/dist/index.esm.js';
var activeStyle = {
  border: "2px solid",
  borderColor: "textPrimary",
  backgroundColor: "grey.4",
  fontWeight: "600"
};
var Label = styled.label(function (_a) {
  var isChecked = _a.isChecked;
  return css(__assign({
    boxSizing: "border-box",
    width: "100%",
    cursor: "pointer",
    display: "flex",
    userSelect: "none",
    px: "32px",
    alignItems: "center",
    justifyContent: "center",
    border: "base",
    borderColor: "grey.5",
    letterSpacing: "sm",
    transition: "200ms ease-in-out, font-weight 0ms",
    ":hover": {
      backgroundColor: "grey.8"
    }
  }, isChecked ? activeStyle : {}));
}, variant({
  prop: "size",
  variants: {
    sm: {
      height: "36px",
      borderRadius: "36px",
      fontSize: "paragraph.sm",
      lineHeight: "paragraph.sm"
    },
    md: {
      height: "40px",
      borderRadius: "40px",
      fontSize: "paragraph.md",
      lineHeight: "paragraph.md"
    }
  }
}), width, padding);
var Input = styled.input(visuallyHiddenStyle);
var RadioButton = React__default.forwardRef(function (_a, ref) {
  var children = _a.children,
    width = _a.width,
    paddingX = _a.paddingX,
    px = _a.px,
    size = _a.size,
    rest = __rest(_a, ["children", "width", "paddingX", "px", "size"]);
  var checked = rest.checked,
    defaultChecked = rest.defaultChecked;
  var isChecked = React__default.useMemo(function () {
    if (checked !== undefined) {
      return checked;
    }
    return defaultChecked;
  }, [checked, defaultChecked]);
  return React__default.createElement(Label, {
    isChecked: isChecked,
    width: width,
    px: px || paddingX,
    size: size || "md"
  }, React__default.createElement(Input, __assign({}, rest, {
    type: "radio",
    ref: ref
  })), children);
});
export { RadioButton };